import React from "react";
import Ionicon from "react-ionicons";
import { Link } from "react-router-dom";

/*
The top section of the side nav bar holding a logo and a side nav toggle button.
 */
const SideNavTopBar = () => {
  return (
    <div className="app-brand demo">
      <span className="app-brand-logo demo ">
      </span>
      <Link
        to="/home"
        className="app-brand-text demo sidenav-text font-weight-normal ml-2"
      >
        Anglo iForms
      </Link>
      <a
        className="layout-sidenav-toggle sidenav-link text-large ml-auto"
      >
        <Ionicon icon="ios-menu" className="sidenav-icon" color="#9d9fa1" />
      </a>
    </div>
  );
};

export default SideNavTopBar;



// WEBPACK FOOTER //
// ./src/views/components/sidenav/sidenavTopBar.js